// src/pages/login/LoginForm.jsx
import React from "react";
import { FaEye, FaEyeSlash, FaUser, FaLock } from "react-icons/fa";

const LoginForm = ({
  email,
  password,
  showPassword,
  isSubmitting,
  error,
  emailRef,
  setEmail,
  setPassword,
  setShowPassword,
  handleSubmit,
  navigate,
}) => {
  return (
    <form onSubmit={handleSubmit} autoComplete="off" className="space-y-6">
      <div>
        <label className="block mb-1 text-sm font-semibold text-green-800">
          Email
        </label>
        <div className="relative">
          <span className="absolute text-green-500 -translate-y-1/2 left-3 top-1/2">
            <FaUser />
          </span>
          <input
            autoComplete="username"
            name="user_email"
            ref={emailRef}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full py-2 pl-10 pr-3 border border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
            required
            placeholder="email@example.com"
          />
        </div>
      </div>

      <div>
        <label className="block mb-1 text-sm font-semibold text-green-800">
          Password
        </label>
        <div className="relative">
          <span className="absolute text-green-500 -translate-y-1/2 left-3 top-1/2">
            <FaLock />
          </span>
          <input
            autoComplete="current-password"
            name="user_pass"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full py-2 pl-10 pr-10 border border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
            required
            placeholder="••••••••"
          />
          <button
            type="button"
            className="absolute text-green-600 -translate-y-1/2 right-3 top-1/2"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
      </div>

      {error && <div className="text-sm text-center text-red-600">{error}</div>}

      <button
        type="submit"
        disabled={isSubmitting}
        className={`w-full py-2 font-semibold text-white transition duration-300 shadow-md rounded-xl ${
          isSubmitting
            ? "bg-green-400 cursor-not-allowed"
            : "bg-green-600 hover:bg-green-700"
        }`}
      >
        {isSubmitting ? "Memproses..." : "Masuk"}
      </button>

      <div className="mt-4 text-sm text-center">
        <button
          type="button"
          onClick={() => navigate("/reset-password")}
          className="text-green-700 underline hover:text-green-800"
        >
          Lupa Password?
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
